module.exports = "<div class=\"container faq-custom\" [innerHtml]=\"texto\">\r\n</div>"